import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class {
  constructor(options={}) {
    this.options = {
      selectors : {
        mobileButton: '[data-mobile-button]',
        navList: '[data-nav-list]',
        mobileNavList: '[data-mobile-nav-list]'
      },
      classes : {
        navToggle: 'header__mobile-menu--toggled',
        iconActive: 'header__menu-icon--active',
        submenuOpen: 'header__submenu--open',
        mobileButtonToggled: 'header__button-mobile--toggled'
      },
      ...options};

    this.init();

    this.mobileClick();

    this.navClick();
  }

  init() {
    this.mobileButton = document.querySelector(this.options.selectors.mobileButton);
    this.navList = document.querySelector(this.options.selectors.navList);
    this.mobileNavList = document.querySelector(this.options.selectors.mobileNavList);
  }

  mobileClick() {
    if (this.mobileButton) {
      this.mobileButton.addEventListener('click', event => {
        this.mobileNavList.classList.toggle(this.options.classes.navToggle);
        this.mobileButton.classList.toggle(this.options.classes.mobileButtonToggled);
        if(this.mobileButton.matches(`.${this.options.classes.mobileButtonToggled}`)) {
          disableBodyScroll(this.mobileNavList)
        }
        else {
          enableBodyScroll(this.mobileNavList)
        }
      })
    }
  }

  hideNav() {
    this.navList.querySelectorAll(`.${this.options.classes.submenuOpen}`).forEach(element => element.classList.remove(this.options.classes.submenuOpen));
    this.navList.querySelectorAll(`.${this.options.classes.iconActive}`).forEach(element => element.classList.remove(this.options.classes.iconActive));
  }

  navClick() {
    if (this.navList) {
      document.addEventListener('click', event => {
        if (event.target.closest('.header__menu-link')) {
          let submenuOpen = event.target.nextElementSibling.matches(`.${this.options.classes.submenuOpen}`);
          this.hideNav();
          if (!submenuOpen) {
            event.target.nextElementSibling.classList.add(this.options.classes.submenuOpen);
            event.target.querySelector('svg').classList.add(this.options.classes.iconActive);
          }
          event.preventDefault();
        }
        else {
          this.hideNav();
        }
      })
    }
  }
}
